import { getCompanyRepresentative } from './getCompanyRepresentative';

/**
 * アップロード時のデフォルト担当者（#2642・#3061）
 */
export interface DefaultAssignee {
  /** 担当者UID。未設定時は null */
  uid: string | null;
  /** 担当者表示名（非正規化保存用スナップショット）。未設定時は null */
  name: string | null;
  /** 担当者アイコンURL（非正規化保存用スナップショット）。未設定時は null */
  iconUrl: string | null;
}

interface ResolveDefaultAssigneeParams {
  /** 代理ログイン中か */
  isProxyMode: boolean;
  /** 代理対象企業の company_id（代理モード時のみ使用） */
  companyId: string | null | undefined;
  /** アップロード操作を行うログインユーザー */
  user: { uid: string; name?: string | null; iconUrl?: string | null };
}

/**
 * アップロード時のデフォルト担当者を解決する（#2642・#3061 で共通化）
 *
 * - 通常モード: アップロード本人を担当者にする
 * - 代理モード: 代理対象企業の企業担当者を担当者にする。取得できない場合は未設定（null）。
 *   運営ユーザー(操作者)は代理先企業のメンバーではないため担当者にしない
 *   （担当者にすると一覧で「退会済ユーザー」表示になるため。#2856）
 *
 * パターンOCR・自由読取・自動仕分けの各アップロード経路で共通利用する。
 */
export const resolveDefaultAssignee = async ({
  isProxyMode,
  companyId,
  user,
}: ResolveDefaultAssigneeParams): Promise<DefaultAssignee> => {
  if (!isProxyMode) {
    return {
      uid: user.uid,
      name: user.name ?? '',
      iconUrl: user.iconUrl ?? null,
    };
  }

  if (companyId) {
    try {
      const rep = await getCompanyRepresentative(companyId);
      if (rep?.uid) {
        return { uid: rep.uid, name: rep.name, iconUrl: rep.iconUrl };
      }
    } catch {
      // 取得失敗時は未設定のまま（運営ユーザーへはフォールバックしない）
    }
  }

  return { uid: null, name: null, iconUrl: null };
};
